import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from './ui/button';

interface PermissionErrorPageProps {
  error?: string | Error;
}

export function PermissionErrorPage({ error }: PermissionErrorPageProps) {
  const navigate = useNavigate();
  const errorMessage = error instanceof Error ? error.message : error;

  return (
    <div className="min-h-screen bg-[#FBFBFA] flex flex-col items-center justify-center px-4 py-12">
      <img
        src="/logo_colorato.png"
        alt="Flusia"
        className="h-8 w-auto mb-12 opacity-80"
      />

      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl p-10 text-center">
        <div className="mx-auto mb-6 h-16 w-16 rounded-full bg-amber-50 flex items-center justify-center">
          <AlertTriangle className="h-8 w-8 text-amber-500" strokeWidth={1.5} />
        </div>

        <h1 className="text-3xl font-semibold text-gray-900 mb-3 tracking-tight">
          Errore nel caricamento dei permessi
        </h1>

        <p className="text-base text-gray-500 leading-relaxed mb-8">
          Si è verificato un problema temporaneo nel caricamento dei permessi.
          Riprova tra qualche istante o torna alla dashboard.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
          <Button
            variant="default"
            onClick={() => window.location.reload()}
            className="gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            Ricarica pagina
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/dashboard')}
            className="gap-2"
          >
            <Home className="h-4 w-4" />
            Vai alla dashboard
          </Button>
        </div>

        {errorMessage && (
          <div className="pt-6 border-t border-gray-100">
            <p className="text-xs text-gray-400 font-mono">
              {errorMessage}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
